import type { GetFeaturesInnerParams } from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { type Feature } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
// eslint-disable-next-line import/no-cycle
import {
  getAccommodationDates,
  getFlexibleFeatures,
  getLiveSearchFeatures,
  getOpxFlexDates,
} from '@/app/components/search/components/Card/Details/Features/getFeatures/utils/getDateFeaturesUtils.tsx';

export const getDateFeatures = (params: GetFeaturesInnerParams): Feature[] => {
  const { datesText, isHO, isFlexible, isLiveSearch, isPartialStay, hasOpxFlexDates } = params;

  const features: Feature[] = [];

  // Early return conditions
  const isHOLiveSearch = isHO && !isFlexible;
  if (isHOLiveSearch || !datesText) return []; // Handle non-flexible date scenarios

  // Handle flexible dates scenarios
  if (isFlexible) {
    features.push(...getFlexibleFeatures(params));
  }

  // Handle live search scenarios
  if (isLiveSearch) {
    if (isPartialStay) {
      //  Show hotel dates when different from widget dates
      features.push(...getAccommodationDates(params));
    }
    if (hasOpxFlexDates) {
      // show trip dates when different from the widget dates
      features.push(...getOpxFlexDates(params));
    }

    features.push(...getLiveSearchFeatures(params));
  }

  return features;
};
